import "./App.scss";
import { ThemeProvider } from "@mui/material";
import { Route, Routes } from "react-router";
import { Landing } from "./pages/Landing/Landing";
import theme from "./utils/theme";
import { Tasks } from "./pages/Tasks/Tasks";
import { Navbar } from "./components/Navbar/Navbar";
import { Images } from "./pages/Images/Images";
import { useState, useEffect } from "react";
import { Admin } from "./pages/Admin/Admin";
import { Help, HelpType } from "./components/Help/Help";
import { AllTasks } from "./pages/AllTasks/AllTasks";
import { Batch } from "./pages/Batch/Batch";

function App() {
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [help, setHelp] = useState<HelpType>(HelpType.NONE);

  useEffect(() => {
    if (sessionStorage.getItem("authenticated") === "true") {
      setAuthenticated(true);
    }
  }, []);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Help help={help} setHelp={setHelp} />
        <Navbar authenticated={authenticated} setAuthenticated={setAuthenticated} setHelp={setHelp} />
        <Routes>
          <Route
            path="/"
            element={<Landing authenticated={authenticated} setAuthenticated={setAuthenticated} />}
          ></Route>
          {authenticated && (
            <Route path="/tasks" element={<Tasks authenticated={authenticated} setHelp={setHelp} />}></Route>
          )}
          {authenticated && (
            <Route path="/batch" element={<Batch authenticated={authenticated} setHelp={setHelp} />}></Route>
          )}
          {authenticated && (
            <Route path="/tasksAdmin" element={<AllTasks authenticated={authenticated} setHelp={setHelp} />}></Route>
          )}
          {authenticated && <Route path="/admin" element={<Admin authenticated={authenticated} />}></Route>}
          {authenticated && <Route path="/images" element={<Images />}></Route>}
          <Route path="*" element={<h1>Not Found</h1>}></Route>
        </Routes>
      </ThemeProvider>
    </div>
  );
}

export default App;
